export default "__VITE_ASSET__ibIvVlY0__"